import * as React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ArticleRedirector } from '@thd-nucleus/app-render';
import { useParams } from '@thd-olt-component-react/router';
import { Bio } from './Bio';

export const Home = () => {
    const { articleGUID } = useParams();

  return (
    <QueryProvider cacheKey="Home">
      <ArticleRedirector articleGUID={articleGUID} />
      <Bio />
    </QueryProvider>
  );
};

Home.propTypes = {
};

Home.displayName = 'HomePage';

Home.defaultProps = {
  name: '',
};
